export { Hero1 } from './Hero1';
export { Hero2 } from './Hero2';
export { Hero3 } from './Hero3';
export { Hero4 } from './Hero4';
export { Hero5 } from './Hero5';
export { Hero6 } from './Hero6';
export { Hero7 } from './Hero7';
export { Hero8 } from './Hero8';
export { Hero9 } from './Hero9';
export { Hero10 } from './Hero10';
export { Hero11 } from './Hero11';
export { Hero12 } from './Hero12';
export { Hero13 } from './Hero13';
export { Hero14 } from './Hero14';  
export { Hero15 } from './Hero15';
export { Hero16 } from './Hero16';
export { Hero17 } from './Hero17';
export { Hero18 } from './Hero18';
export { Hero19 } from './Hero19';
export { Hero20 } from './Hero20';
export { Hero21 } from './Hero21';
export { Hero22 } from './Hero22';